<template>
  <div class="vrun-form-result-date">
    {{ value * 1000 | angularFilter("EEE d MMM yyyy, HH:mm", "date") }}
  </div>
</template> 
<script>
export default {
  methods: {},
  props: ["value"],
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.vrun-form-result-date {
  padding: 24px 16px;
}
</style>